// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__Bh_vx","logo":"MainNavigation_logo__Lrek4","nav":"MainNavigation_nav__3xMd5","active":"MainNavigation_active__4IAqc"};